import {useContext, useEffect, useRef, useState} from 'react';
import {useDispatch} from 'react-redux';
import {useNavigate} from 'react-router-dom';

import Context from '../Context';
import _axios from '../../../utils/axios';
import {getDateTime, handleError} from '../../../utils/utils';
import {setCase} from '../../../features/case.slice';

import styles from '../../../styles/cases/CaseCard.module.scss';

/**
 * @param {Object} props.case
 *
 * @param {string} props.case.id
 * @param {string} props.case.name
 * @param {Array} props.case.nodes
 * @param {Array} props.case.edges
 * @param {string} props.case.updated_at
 * @param {string} props.case.created_at
 */
function CaseCard(props) {
  const context = useContext(Context);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  function formatDate(datetime) {
    const dt = new Date(datetime);
    const offset = dt.getTimezoneOffset();
    const localDt = new Date(dt.getTime() - (offset*60*1000));
    const localIso = localDt.toISOString();
    const local_date = localIso.split('T')[0];
    const local_time = localIso.split('T')[1].split('.')[0];
    return local_date + ' ' + local_time;
  }

  function openCase(event) {
    event.stopPropagation();
    dispatch(setCase({
      id: props.case.id,
      name: props.case.name,
      nodes: [...props.case.nodes],
      edges: [...props.case.edges],
      createdAt: props.case.created_at,
      updatedAt: props.case.updated_at
    }));
    navigate('/case/' + props.case.name);
  }

  function renameCase(event) {
    event.stopPropagation();
    const newName = window.prompt('Enter a new name for the case', props.case.name);
    if (!newName) return;
    _axios.post(context.role.CASES_PATH + '/rename', {id: props.case.id, name: newName})
      .then(response => {
        context.setCases(cases => {
          const renamedCase = cases.findIndex(_case => _case.id === props.case.id);
          if (renamedCase === -1) return cases;
          cases[renamedCase].name = newName;
          return [...cases];
        });
      });
  }

  function deleteCase(event) {  // TODO
    event.stopPropagation();
    if (!window.confirm('Are you sure you want to delete the case ' + props.case.name + '?')) return;

    const config = {
      data: {id: props.case.id}
    };
    _axios.delete(context.role.CASES_PATH, config)
      .then(response => {
        context.setCases(cases => {
          return cases.filter(_case => _case.id !== props.case.id);
        });
      })
      .catch(handleError);
  }

  return (
    <div className={styles.caseCard} title={'Open ' + props.case.name} onClick={openCase}>
      <div className={styles.header}>
        <p>{props.case.name}</p>
        <div className={styles.rename} title='Rename case' onClick={renameCase}/>
        <div className={styles.delete} title='Delete case' onClick={deleteCase}/>
      </div>

      <div className={styles.content}>
        <p>modified at</p>
        <p>{formatDate(props.case.updated_at)}</p>
        <p>created at</p>
        <p>{formatDate(props.case.created_at)}</p>
      </div>
    </div>
  );
}

export default CaseCard;